document.addEventListener('DOMContentLoaded', () => {
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 940,
    },
  })

  copyURL()
})

const copyURL = () => {
  const url = document.querySelector('.c-gain_friends-search').textContent

  document.querySelector('.c-gain_friends-search').addEventListener('click', async () => {
    navigator.clipboard.writeText(url)

    document.querySelector('.c-gain_friends-search').textContent = 'コピーしました！'
    const handler = () => {
      document.querySelector('.c-gain_friends-search').removeEventListener('mouseleave', handler)
      document.querySelector('.c-gain_friends-search').textContent = url
    }
    document.querySelector('.c-gain_friends-search').addEventListener('mouseleave', handler)
  })
}
